import { observable } from "mobx";
import { Type } from "class-transformer";
import CustomerPartialRefundCandidatePreviewDetailResponse from "./customerPartialRefundCandidatePreviewDetailResponse";
import CustomerPartialRefundCandidateRejectionReason from "./customerPartialRefundCandidateRejectionReason";
import type CustomerPartialRefundCandidateWarningReason from "./customerPartialRefundCandidateWarningReason";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CustomerPartialRefundCandidatePreviewResponse {
  /**
   * If true - candidate can be submitted.
   */
  @observable
  canBeSubmitted!: boolean;

  /**
   * Requested fuel type ID.
   */
  @observable
  fuelTypeId!: string;

  @observable
  _newFuelTypeId?: string;

  /**
   * Official record ID.
   */
  @observable
  officialRecordId!: string;

  /**
   * E-mail address.
   */
  @observable
  emailAddress?: string;

  @observable
  rejectionReason?: CustomerPartialRefundCandidateRejectionReason;

  /**
   * Allowed fuel type ID derived from vehicle register data (fuel type and emissions).
   */
  @observable
  allowedFuelTypeId?: string;

  /**
   * Warning reasons.
   */
  @observable
  warningReasons!: CustomerPartialRefundCandidateWarningReason[];

  @observable
  @Type(() => CustomerPartialRefundCandidatePreviewDetailResponse)
  candidatePreview!: CustomerPartialRefundCandidatePreviewDetailResponse;
}
